import React from 'react';
import './Beverageinject.css';
import img1 from '../../../imgs/cavities1.webp';
import img2 from '../../../imgs/cavities2.webp';
import img3 from '../../../imgs/cavities3.webp';

const machines = [
  {
    img: img1,
    title: 'Model: PET1500',
    mould: '32 Cavities',
    weight: '18g',
    cycle: '18s'
  },
  {
    img: img2,
    title: 'Model: PET2100',
    mould: '48 Cavities',
    weight: '20g',
    cycle: '21s'
  },
  {
    img: img3,
    title: 'Model: KPET3105L',
    mould: '72 Cavities',
    weight: '13.5g',
    cycle: '12.9s'
  }
];

const Beverageinject = () => {
  return (
    <div className="beverage-wrapper">
      <h2 className="beverage-heading">Beverage PET Preform Injection Molding Machine Solutions</h2>
      <div className="beverage-card-container">
        {machines.map((item, index) => (
          <div className="beverage-card" data-aos="fade-down" key={index}>
            <img src={item.img} alt={item.title} className="beverage-img" />
            <div className="beverage-details">
              <h3>{item.title}</h3>
              <p><strong>Mould:</strong> {item.mould}</p>
              <p><strong>Preform Weight:</strong> {item.weight}</p>
              <p><strong>Cycle Time:</strong> {item.cycle}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Beverageinject;
